import {Injectable, inject} from '@angular/core';
import {Observable} from 'rxjs';
import {ApiClient, CreditCandidateInfo} from '../sdk/sdk';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private readonly sdk = inject(ApiClient);

  getCreditCandidates(jobId: string, branchId: string): Observable<CreditCandidateInfo[]> {
    return this.sdk.getCreditCandidates(jobId, branchId);
  }

  getAllCreditCandidates(): Observable<CreditCandidateInfo[]> {
    return this.sdk.getAllCreditCandidates();
  }
}
